"use strict";

exports.__esModule = true;
exports["default"] = {
  DATE_ROW_COUNT: 6,
  DATE_COL_COUNT: 7
};
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./node_modules/_rc-calendar@9.15.11@rc-calendar/lib/date/DateConstants.js
// module id = 396
// module chunks = 0